export const openChat = () =>
  window.open(`https://vk.com/write-${window.GROUP_ID}`, '_blank');

// give the user some time to see the notification
export const openChatWithDelay = () => setTimeout(openChat, 1000);
